module.exports = __webpack_public_path__ + "static/media/m_b_0.7829107b.png";